<template>
  <div class="p-grid">
    <div class="p-col-12">
      <CustomBreadcrumb :items="items_bread_crumb"  />
      <div class="card card-w-title">
        <div class="manager-title">{{ title }}</div>
        <div class="row p-3 justify-content-between">
          <div class="col-8 row">
            <div class="row ml-0 mr-4 align-items-center" v-for="(item, index) in colorArr" :key="`color-${index}`"
              v-show="displayCalendar">
              <div class="color-box" :style="`background-color: ${item}`"></div>
              <div>Part {{ index + 1 }}</div>
            </div>
          </div>
          <!--          <div class="col-4 row justify-content-end">
                      <Button icon="pi pi-list" class='mr-2 button-display' :class="`${displayList ? 'active': ''}`" @click="changeDisplay('displayList', 'displayCalendar')"/>
                      <Button icon="pi pi-calendar" class="button-display" :class="`${displayCalendar ? 'active': ''}`" @click="changeDisplay('displayCalendar', 'displayList')"/>
                      </div>-->
        </div>
        <!--        <calendarTable
                  v-if="displayCalendar"
                />-->
        <!--{{listData}}-->
        <BaseDatatable v-if="dataModel && componentKey>0" :key="componentKey" :tableData="listData" :model="dataModel"
          :options="options" :filterDefault="filters" :getFilterOptions="getFilterOptions" :actions="getRowActions()"
          v-on:action-click="onActionClicked"
          @onRowSelect="onRowSelect"
          ></BaseDatatable>
        <!--    @onDataChange = 'DataOnChange'     -->

        <Dialog header="Delete" :visible.sync="showDeleteDialog" :contentStyle="{ overflow: 'visible' }" :modal="true">
          Are you want to delete this User ?
          <template #footer>

            <Button label="Cancel" @click="showDeleteDialog = false" icon="pi pi-times" class="p-button-warning" />
            <Button label="Confirm" @click="deleteData()" icon="pi pi-check"
                    class="p-button-danger  btn-confirm-delete-dialog" />
          </template>
        </Dialog>

        <Dialog
      :header="`Complete this booking`"
      :visible.sync="showConfirmDialogComplete"
      
       :contentStyle="{ overflow: 'visible',maxHeight: '80vh', overflowY: 'auto',width: '600px' }"
      :modal="true"
    >
      Are you sure you want to complete this booking? <br /><br />
      <!-- Please note: Once confirmed, the payment details will become uneditable <br>
          within the system. -->
      <div class="popup-row">
        <div class="popup-title">Refund bond fee</div>
        <div style="color: #F5564E;font: normal normal bold 16px/19px Segoe UI;" class="popup-money" v-if="!$commonFuction.isEmpty(obj_data.refund_bond_fee)">{{obj_data.refund_bond_fee}}</div>
      </div>
      <div class="popup-row">
        <div class="popup-title">Renter’s final payment </div>
        <div style="color: #00973C;font: normal normal bold 16px/19px Segoe UI;" class="popup-money" v-if="!$commonFuction.isEmpty(obj_data.renter_final_payment)">{{obj_data.renter_final_payment}}</div>
      </div>
      <template #footer>
        
        <Button
          label="Cancel"
          @click="showConfirmDialogComplete = false"
          icon="pi pi-times"
          class="p-button-warning"
        />
        <Button
         
          label="Confirm"
         @click="confirmDataPopup('confirm_final_payment')"
          icon="pi pi-check"
          class="p-button-danger btn-confirm-delete-dialog style-btn-popup-confirm"
        />
          <!-- @click="confirmDataPopup('CONFIRM_PICK_UP')" -->
      </template>
    </Dialog>


 <Dialog
      :header="`Dismiss warning for this week?`"
      :visible.sync="showConfirmDialogWarning"
      
       :contentStyle="{ overflow: 'visible',maxHeight: '80vh', overflowY: 'auto',width: '600px' }"
      :modal="true"
    >
      Are you sure you want to dismiss this warning? This action cannot be undone. <br /><br />
      <!-- Please note: Once confirmed, the payment details will become uneditable <br>
          within the system. -->
      <!-- <div class="popup-row">
        <div class="popup-title">Refund bond fee</div>
        <div style="color: #F5564E;font: normal normal bold 16px/19px Segoe UI;" class="popup-money">2222222222</div>
      </div>
      <div class="popup-row">
        <div class="popup-title">Renter’s final payment</div>
        <div style="color: #00973C;font: normal normal bold 16px/19px Segoe UI;" class="popup-money">2222222222222</div>
      </div> -->
      <template #footer>
        
        <Button
          label="Cancel"
          @click="showConfirmDialogWarning = false"
          icon="pi pi-times"
          class="p-button-warning"
        />
        <Button
         
          label="Confirm"
        @click="confirmDataPopup('warning')"
          icon="pi pi-check"
          class="p-button-danger btn-confirm-delete-dialog style-btn-popup-confirm"
        />
          <!-- @click="confirmDataPopup('CONFIRM_PICK_UP')" -->
      </template>
    </Dialog>

      </div>
    </div>
  </div>
</template>

<script>
import DataServices from '@/core/DataServices'
import BaseDatatable from './list'
import ApiRepository from "@/core/ApiRepository";
//import calendarTable from './calendar'
// import gql from "graphql-tag";
// import Popup from './popup'
export default {
  components: {
    BaseDatatable,
    //calendarTable
    // Popup
  },
  data() {
    return {
      items_bread_crumb: [
        { label: 'Rental Order'},
      ],
      obj_data:{},
      displayList: true,
      displayCalendar: false,
      filters: {},
      filterOptions: {},
      options: [],
      listData: [],
      modelName: '',
      dataModel: null,
      title: '',
      componentKey: 0,
      countRelationship: 0,
      editId: null,
      displayDialog: false,
      editDialogKey: 0,
      dialogMode: 'edit',
      deleteId: null,
      deleteName: null,
      showDeleteDialog: false,
      whereKeyList: {
        where_key: {
          /*accounts: {
            role: {_eq: "admin"},
            deleted: {_eq: false}
          },*/
          deleted: { _eq: false }
        }
      },
      page_transaction: null,

      showConfirmDialogWarning: false,
      showConfirmDialogComplete: false,

      role: {
        view: false,
        add: false,
        edit: false,
        delete: false,
      },
      colorArr: [
        '#BBB2F9',
        '#F8D8AB',
        '#BBEFA8',
        '#A7C3FA',
        '#F3B1AF'
      ]
    }
  },
  mounted() {
    this.initParams();
  }
  ,
  async created() {
    this.modelName = this.$route.meta.model;
    this.dataModel = DataServices.getModel(this.modelName);
    console.log('this.modelName:', this.modelName);
    this.title = this.dataModel.name
    this.$store.commit('setLoading', true);
    if (this.$route.params.reload) {
      window.location.reload();
    }
    var arr_role = await this.$CoreService.checkPermission(this.$constants.KEY_MENU.LIST_RENTAL_ORDER);
    console.log('arr_role',arr_role)
    if (arr_role.indexOf(this.$constants.ROLE.VIEW) < 0) {
      this.$router.push({ path: this.$constants.URL_ERR.FOBIDDEN });
    }
    // console.log("arr_role:" ,arr_role)
    this.role.add = (arr_role.indexOf(this.$constants.ROLE.ADD) < 0) ? false : true;
    this.role.edit = (arr_role.indexOf(this.$constants.ROLE.EDIT) < 0) ? false : true;
    this.role.delete = (arr_role.indexOf(this.$constants.ROLE.DELETE) < 0) ? false : true;
    // if (this.$route?.query && this.$route.query?.view == 'calendar') {
    //   this.changeDisplay('displayCalendar', 'displayList');
    // }
    // var arr_role_clubs = await this.$CoreService.checkPermission(this.$constants.KEY_MENU.LIST_CLUBS);
    // // console.log('role_clubrole_club',arr_role_clubs)
    // if (arr_role_clubs.indexOf(this.$constants.ROLE.VIEW) < 0){
    //   this.view_club = false;
    // }else{
    //   this.view_club = true;
    // }
    // console.log('this.view',this.view_club)
  },
  /*watch: {
    '$route': 'initParams'
  },*/
  methods: {
    async loadCallFee() {
      var rent_pay_bond_fee = (this.obj_data.rent_pay_bond_fee) ? parseFloat(this.obj_data.rent_pay_bond_fee) : 0;
      var rent_list_owe = this.obj_data?.rent_list_owe ?? [];
      var rent_list_other_cost = this.obj_data?.rent_list_other_cost ?? [];
      var total_owe = 0;
      var total_other_cost = 0;
      var total_bill_owe = 0;
      var total_bill_other_cost = 0;
      for (let i = 0; i < rent_list_owe.length; i++) {
            var itemData = rent_list_owe[i];
           var amount_owe = (!this.$commonFuction.isEmpty(itemData?.amount)) ? parseFloat(itemData.amount):0;
            total_owe += amount_owe;
            total_bill_owe ++;
        }
        for (let h = 0; h < rent_list_other_cost.length; h++) {
            var itemData1 = rent_list_other_cost[h];
            var amount_cost = (!this.$commonFuction.isEmpty(itemData1?.amount)) ? parseFloat(itemData1.amount):0;
            total_other_cost += amount_cost;
            total_bill_other_cost++;
        }
        //listDataOtherCost
        // for (let j = 0; j < this.listDataOtherCost.length; j++) {
        //     var itemData2 = this.listDataOtherCost[j];
        //     var amount_cost2 = (!this.$commonFuction.isEmpty(itemData2?.amount)) ? parseFloat(itemData2.amount):0;
        //     total_other_cost += amount_cost2;
        //      total_bill_other_cost++;
        // }
        this.obj_data.total_bill_owe = total_bill_owe;
        this.obj_data.total_bill_other_cost = total_bill_other_cost;
        this.obj_data.rent_pay_bond_fee_filnal ='-$'+((rent_pay_bond_fee ) ? this.$commonFuction.numberFormat(rent_pay_bond_fee, 2, '.', ','):'0.00') ;
        this.obj_data.total_owe_filnal ='$'+((total_owe ) ? this.$commonFuction.numberFormat(total_owe, 2, '.', ','):'0.00') ;
        this.obj_data.total_other_cost_filnal ='$'+((total_other_cost ) ? this.$commonFuction.numberFormat(total_other_cost, 2, '.', ','):'0.00') ;
        var total_final_payment = -rent_pay_bond_fee +total_owe+total_other_cost;
        var renter_final_payment = 0;
        var refund_bond_fee = 0;
        if(total_final_payment >0){
          renter_final_payment = total_final_payment;
         // this.show_request = true;
        }else{
          refund_bond_fee = total_final_payment;
         // this.show_request = false;
        }
        // if(this.obj_data.rent_is_request_final_payment ==true){
        //     this.show_request = false;
        // }
        this.obj_data.renter_final_payment ='$'+((renter_final_payment ) ? this.$commonFuction.numberFormat(renter_final_payment, 2, '.', ','):'0.00') ;
        this.obj_data.refund_bond_fee ='-$'+((refund_bond_fee ) ? this.$commonFuction.numberFormat(Math.abs(refund_bond_fee), 2, '.', ','):'0.00') ;
    },
    async confirmDataPopup(code) {
      // var code_order = this.obj_data.code
      // var prefix_code = code_order.substring(0, 2);
      var obj_res ={};
      var dataRequest = {};
      switch (code) {
        case 'warning':
            //check chọn xe License plate number
             dataRequest = {
              obj_data: this.obj_data,
            }
             this.$commonFuction.is_loading(true);
            obj_res = await this.$CoreService.sendApi('/api_admin/order/turn_off_warnings',dataRequest);
            
            if(obj_res.is_success ==true){
              alert(this.$constants.MSG_TEXT.CONFIRMED_SUCCESSFULLY);
              this.showConfirmDialogWarning = false;
              window.location.reload();
            }else{
               this.$commonFuction.is_loading(false);
              alert(obj_res.message_text);
            }
          break;
        case 'confirm_final_payment':
             dataRequest = {
              type_action:2,
              id:this.obj_data.id
            }
            
             this.$commonFuction.is_loading(true);
            obj_res = await this.$CoreService.sendApi('/api_admin/order/complete_payment_request',dataRequest);
            
            if(obj_res.is_success ==true){
              alert(this.$constants.MSG_TEXT.CONFIRMED_SUCCESSFULLY);
              this.showConfirmDialogComplete = false;
              window.location.reload();
            }else{
               this.$commonFuction.is_loading(false);
              alert(obj_res.message_text);
            }
          break;   
        default:
          //text = "Looking forward to the Weekend";
      }
    },
     onRowSelect(data) {
      console.log('data', data);
      if (this.role.edit) {
        this.$router.push({path: `/admin/list-rental_order/view/${data.id}`, query: { page_transaction: (new Date()).getTime().toString() }});
      }
    },
    changeDisplay(activeData, unactiveData) {
      this.$set(this, activeData, true);
      this.$set(this, unactiveData, false);
      this.componentKey++;
    },
    async initParams() {
      this.$store.commit('setLoading', true);
      this.modelName = this.$route.meta.model;
      this.dataModel = DataServices.getModel(this.modelName);
      this.title = this.dataModel.label;
      await this.callbackOptions();
      this.componentKey++;
    },
    async callbackOptions() {
      var fields = this.dataModel.getDisplayFields();
      for (let index = 0; index < fields.length; index++) {
        var attributes = [];
        const element = fields[index];
        if (element.models !== undefined && element.models !== null) {
          // console.log("SDFGHJK",element)
          var optionsData = [];
          attributes.push(element.models.key.key);
          attributes.push(element.models.display_key);
          var where_ = {}
          var result;
          if (element['name'] == 'group_channel_name') {
            where_ = {
              active: { _eq: true },
              deleted: { _eq: false },
            }
          }
          if (element['name'] == 'channel_name') {
            where_ = {
              active: { _eq: true },
              deleted: { _eq: false },
            }
          }
          if (element['name'] == "service_name") {
            // console.log("element",element)
            let { data } = await this.$apollo.query({
              query: DataServices.getList("service", { "fields": "id name" }),
              variables: {
                where_key: {
                  deleted: { _eq: false },
                  parent_id: { _is_null: true }
                },
                orderBy: [{ ordinal: 'desc' }, { created_at: 'desc' }]
              }
            })
            if (data) {
              result = data[Object.keys(data)];
              if (result) {
                for (let index = 0; index < result.length; index++) {
                  const ele = result[index];
                  optionsData.push({ value: ele[attributes[0]], label: ele[attributes[1]] })
                }
              }
            }
          } else {
            if (element['name'] == 'group_channel_name') {
              where_ = {
                "channel": {
                  "deleted": {
                    "_eq": false
                  }
                },
                "deleted": {
                  "_eq": false
                }
              }
            } else {
              if (element.where_option) {
                where_ = element.where_option
              }
            }
            let { data } = await this.$apollo.query({
              query: DataServices.getList(element.models.tableName, { "fields": attributes.join(',') }),
              variables: { where_key: where_ }
            })
            if (data) {
              result = data[Object.keys(data)];
              if (result) {
                for (let index = 0; index < result.length; index++) {
                  const ele = result[index];
                  optionsData.push({ value: ele[attributes[0]], label: ele[attributes[1]] })
                }
              }
            }
          }
          // console.log("optionsData",optionsData)
          this.options[element.key] = optionsData;
        }
        
      }
      
    },
    getFilterOptions(name) {
      var field = this.dataModel.getField(name)
      var result = []
      if (field.type == 'Selection') {
        if (field.options) result = field.options;
        else if (field.models && this.options[name]) result = this.options[name];
      } else {
        if (field.options) { result = field.options; }
        else if (field.models && this.options[name]) result = this.options[name];
        else {
          result = this.filterOptions[name] != null ? [...this.filterOptions[name]] : []
        }
      }
      return result;
    },
    getRowActions() {
      var actions = {}
      var that = this;
      if (this.role.add) {
        actions.header = { name: 'add', icon: 'plus', path: `list-rental_order/add` };
      }
      // actions.header = { name: 'add', icon: 'plus'};
      actions.rows = function (rowData) {
        var booking_status = rowData?.booking_status ?? null
        var type_warning = rowData?.type_warning ?? 0;
        var rent_is_request_final_payment = rowData?.rent_is_request_final_payment ?? false;
        var rent_is_pay_final_payment = rowData?.rent_is_pay_final_payment ?? false;
        var buttons = {}
        //buttons.view = { name: 'view', icon: 'eye', key: 'id', path: `list-rental_order/view/`};
        if (that.role.edit) {
          if (booking_status ==that.$constants.STATUS_ORDER.BOOKED_RENT){
            buttons.edit = { name: 'edit', icon: 'pencil', key: 'id', path: `list-rental_order/edit/` };
          }
        }
        // buttons.edit = { name: 'edit', icon: 'pencil', key: 'id', path: `${that.modelName}/edit/`}
        if (that.role.delete) {
         if (booking_status ==that.$constants.STATUS_ORDER.BOOKED_RENT || booking_status ==that.$constants.STATUS_ORDER.CANCEL_RENT || booking_status ==that.$constants.STATUS_ORDER.TEMP_RENT){
            buttons.delete = {name: 'delete', icon: 'trash', key: 'id'}
          }
        }
        if(parseInt(type_warning) ==that.$constants.TYPE_WARNING_ORDER.WARNING){
          buttons.warning = { name: 'warning', icon: 'eye', key: 'id', path: `list-rental_order/view/`,url_icon:'/assets/images/icon/ic_warning_yelow.svg'};
        }
        if(rent_is_request_final_payment == true && rent_is_pay_final_payment == false){
        buttons.confirm_final_payment = { name: 'confirm_final_payment', icon: 'eye', key: 'id', path: `list-rental_order/view/`,url_icon:'/assets/images/icon/complete_list.svg'};
        }
        if (that.dataModel.actions) {
          var modelaction = that.dataModel.actions(rowData)
          Object.assign(buttons, modelaction);
        }
        return buttons
      }
      return actions
    },
    async onActionClicked(payload) {
      var action = payload.action
      var data = null
      if (payload.data) {
        data = payload.data
      }
      var pageTransaction = (new Date()).getTime();
      switch (action.name) {
        case 'view':
          this.dialogMode = action.name
          if (action.path !== undefined && action.path) {
            this.$router.push({ path: action.path + data.data[action.key] })
          } else {
            this.editId = data.data[action.key]
            this.displayDialog = true
            this.editDialogKey++
          }
          break
        case 'edit':
          this.dialogMode = action.name
          if (action.path !== undefined && action.path) {
            console.log("payload.lazyParams:111" + pageTransaction, payload.lazyParams);
            localStorage.setItem(pageTransaction.toString(), JSON.stringify(payload.lazyParams));
            this.$router.push({ path: action.path + data.data[action.key], query: { page_transaction: pageTransaction.toString() } })
          } else {
            this.editId = data.data[action.key]
            this.displayDialog = true
            this.editDialogKey++
          }
          break
        case 'delete':
          localStorage.setItem(pageTransaction.toString(), JSON.stringify(payload.lazyParams));
          this.page_transaction = pageTransaction;
          console.log(data.data);
          this.deleteId = data.data[action.key]
          // this.countRelationship = (data.data.users_club_expiration_aggregate.aggregate.count + data.data.users_setting_sports_aggregate.aggregate.count + data.data.users_stripe_aggregate.aggregate.count + data.data.bookings_aggregate.aggregate.count);
          this.deleteName = data.data.name
          this.showDeleteDialog = true
          break
        case 'add':
          this.dialogMode = action.name
          if (action.path !== undefined && action.path) {
            this.$router.push({ path: action.path })
          } else {
            this.displayDialog = true
            this.editDialogKey++
          }
          break
        case 'custom':
          await action.handler(data.data, this)
          this.componentKey++
          break
        case 'warning':
        this.obj_data = data.data
        this.showConfirmDialogWarning = true;
        break
        case 'confirm_final_payment':
    var dataRequest = {
        id_fil:data.data.id
      }
      var headers = {
        "Authorization": "Bearer "+(await this.$AuthenticationApp.getToken())
      };
     /* this.$emit("emit_filter", dataRequest);
      this.data_filter = dataRequest;*/
      var list_action_detail = await ApiRepository.post('/api_admin/order/detail_order', dataRequest, {headers});
      var itemData = list_action_detail["data"]["data"]
      this.obj_data = itemData;
      console.log("itemData",itemData)
      this.loadCallFee();
        this.showConfirmDialogComplete = true;
        break
      }
    },
    async deleteData() {
      this.showDeleteDialog = false;
      let variables = {
        'data_update': { 
          deleted: true,
          active:false,//set active =false để ẩn thêm đơn temp vì đơn tạm deleted=true
        },
        'where_key': {
          'id': { '_eq': this.deleteId }
        }
      }
      await this.$apollo.mutate({
        mutation: DataServices.updateData('rental_order'),
        variables: variables
      }).then(async (res) => {
        console.log("res", res);
        this.$toast.add({ severity: 'success', summary: 'Success', detail: 'Delete data successfully', life: 3000 })
        this.componentKey++;
      });
    }
  },

}
</script>
<style lang="css">
.p-calendar .p-datepicker {
  width: 280px;
  padding: 0px;
  padding-top: 5px;
}

.p-calendar .p-datepicker td,
.p-calendar .p-datepicker td a {
  padding: 0px !important;
}

.p-calendar .p-datepicker td span {
  padding: 0px !important;
  width: 30px !important;
  height: 30px !important;
}

.p-datepicker .p-datepicker-header {
  padding: 5px !important;
}

/* .p-button-warning .p-button-label {
  color: #1D76BC;
} */

.p-button-warning .pi-times {
  color: #1D76BC;
}

.color-box {
  height: 30px;
  width: 30px;
  margin-right: 10px;
}
</style>